<template>
  <b-container fluid class="no-bottom">
    <b-row>
      <b-col class="d-flex">
        <backlink v-if="this.$route.params.id" class="mt-20" />
        <div class="flex-grow-1">
          <h1>
            <div v-if="!isBusy" class="subtitle">#{{ values.internal_code }}</div>
            <b-badge variant="primary" class="m-t-sm">{{ values.status }}</b-badge>
          </h1>
        </div>
      </b-col>
    </b-row>
    <div v-if="isBusy" class="loader"></div>
    <p v-if="isBusy" class="text-center">Les données sont en cours de chargement...</p>
    <template v-else>
      <b-row v-if="rawValues.status.status_slug == 'reference-en-location'">
        <b-col align="center">
          <b-button variant="primary" size="xxs" class="button-create-return"
            :to="{ name: 'BusinessReturnMobileNew', params: { id: $route.params.id } }">
            Créer un retour
          </b-button>
        </b-col>
      </b-row>
      <b-row v-if="rawValues.status.status_slug == 'reference-en-stock'">
        <b-col align="center">
          <b-button variant="primary" size="xxs" @click="setToMaintenance(values.id)">
            Passer en attente de maintenance
          </b-button>
        </b-col>
      </b-row>
      <b-row v-if="['reference-en-attente-de-maintenance', 'reference-en-maintenance-externe', 'reference-maintenance-planifiee'].includes(rawValues.status.status_slug)">
        <b-col align="center">
          <b-button variant="primary" size="xxs" @click="setToInStock(values.id)">
            Passer en stock
          </b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="ibox">
            <div class="ibox-content divided">
              <b-row v-if="!isBusy">
                <b-col>
                  <h3><i class="far fa-history"></i> Historique de demandes</h3>
                  <div class="table-wrapper">
                    <b-table v-if="rawValues.demands && rawValues.demands.length" class="mt-25" hover
                      :fields="historic_fields" :items="rawValues.demands" sort-by="start_date" :sort-desc="true">
                      <template slot="type" slot-scope="data">{{
          data.value == "renting"
            ? "Location"
            : data.value == "business_return"
              ? "Retour"
              : data.value == "warehouse_transfer"
                ? "Transfert inter-entrepôts"
                : "Transfert"
        }}</template>
                      <template slot="number" slot-scope="data">
                        <routerLink v-if="data.item.type == 'business_return' &&
          data.item.status.slug == 'business-return-transport-en-cours'
          " :to="{ name: 'BusinessReturnMobileDetail', params: { id: data.item.id } }">
                          {{ data.value }}
                        </routerLink>
                        <routerLink v-else-if="data.item.type == 'warehouse_transfer' &&
          ['warehouse-transfer-envoye', 'warehouse-transfer-receptionne-partiellement'].includes(data.item.status.slug)
          " :to="{ name: 'WarehouseTransferMobileDetail', params: { id: data.item.id } }">
                          {{ data.value }}
                        </routerLink>
                        <template v-else>
                          {{ data.value }}
                        </template>
                      </template>
                      <template slot="date" slot-scope="data">{{
          data.value | moment("DD-MM-YYYY")
        }}</template>
                      <template slot="status" slot-scope="data">{{
            $store.getters["status/getItem"](data.value.slug).name
          }}</template>
                    </b-table>
                    <p v-else class="text-left text-muted mt-15 mb-0 pl-4">
                      Aucune demande pour cette référence.
                    </p>
                  </div>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="ibox">
            <div class="ibox-content divided">
              <b-row v-if="rawValues.status.status_slug == 'reference-en-location'">
                <b-col class="d-flex">
                  <div class="pr-25">
                    <h3>Tarification en cours</h3>
                    <dl class="small">
                      <dt>Numéro d'affaire</dt>
                      <dd style="clear: both">{{ currentBusiness.number }}</dd>
                      <dt>Affaire</dt>
                      <dd style="clear: both">{{ currentBusiness.name }}</dd>
                      <dt>Utilisateur</dt>
                      <dd style="clear: both">
                        {{ currentEmployee ? currentEmployee.fullname : "-" }}
                      </dd>
                    </dl>
                  </div>
                  <div class="prices-list flex-grow-1 d-flex" v-if="currentPrice">
                    <div :class="['price', 'flex-fill', 'active']">
                      <dl>
                        <dd>{{ currentPrice.price_value }}€/jour</dd>
                        <dt>{{ currentPrice.label }}</dt>
                      </dl>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-row>
                    <b-col>
                      <h2>
                        <a href @click.prevent="product_id = rawValues.product.id" v-b-modal.modal-product>{{
          values.product
        }}</a>
                      </h2>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <dl class="small">
                        <dt>{{ labels.purchase_date }} :</dt>
                        <dd>{{ values.purchase_date || "-" }}</dd>
                        <dt>{{ labels.purchase_price }} :</dt>
                        <dd>{{ values.purchase_price || "-" }}</dd>
                      </dl>
                      <dl>
                        <dt>{{ labels.internal_code }} :</dt>
                        <dd>{{ values.internal_code || "-" }}</dd>
                        <dt>{{ labels.supplier }} :</dt>
                        <dd>{{ values.supplier || "-" }}</dd>
                        <dt>{{ labels.brand }} :</dt>
                        <dd>{{ values.brand || "-" }}</dd>
                        <dt>{{ labels.model }} :</dt>
                        <dd>{{ values.model || "-" }}</dd>
                        <dt>{{ labels.serial_number }} :</dt>
                        <dd>{{ values.serial_number || "-" }}</dd>
                        <dt>{{ labels.comment }} :</dt>
                        <dd class="nl2br">{{ values.comment || "-" }}</dd>
                      </dl>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row>
                <b-col class="d-flex flex-column">
                  <h3>Stockage</h3>
                  <div class="
                      storage_location
                      flex-grow-1
                      d-flex
                      flex-column
                      justify-content-center
                      flex-nowrap
                    ">
                    <!-- Environnements de stockage du produit, par entrepôt -->
                    <ul v-if="productStorages.length">
                      <li v-for="storage in productStorages" :key="storage.warehouse_id">
                        {{ storageLabel(storage) }}
                      </li>
                    </ul>
                    <b-badge :variant="currentStock <= 0
          ? 'danger'
          : currentStock <= rawValues.product.minimum_stock
            ? 'warning'
            : 'success'
          ">{{ currentStock }} en stock</b-badge>
                  </div>
                </b-col>
                <b-col class="d-flex flex-column barcode-col">
                  <h3>Code barre</h3>
                  <b-row class="flex-grow-1 flex-column barcode-wrapper justify-content">
                    <div class="text-center">
                      <div>{{ values.internal_code }}</div>
                    </div>
                    <div class="text-center">
                      <div>{{ values.product }}</div>
                    </div>
                    <barcode class="text-center" :value="values.internal_code" :displayValue="false" height="50">
                      Impossible de
                      générer le code à barres</barcode>
                  </b-row>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-col>
      </b-row>
    </template>
    <b-modal id="modal-product" hide-footer centered no-close-on-backdrop v-if="product_id">
      <template slot="modal-title">Produit</template>
      <ProductMobileDetail :product_id="product_id"></ProductMobileDetail>
    </b-modal>
  </b-container>
</template>

<script>
import config from "./config";
import AdminModalForm from "../Global/AdminModalForm";
import { environmentLabel } from "@/components/StorageEnvironment/labels";

export default {
  name: "ReferenceMobileDetail",
  components: {
    AdminModalForm,
  },
  data() {
    return {
      config: config,
      labels: {},
      historic_fields: [
        { key: "type", label: "Type" },
        { key: "number", label: "Numéro" },
        { key: "date", label: "Date" },
        { key: "status", label: "Statut" },
      ],
      isBusy: false,
      id_to_edit: null,
      product_id: null,
    };
  },
  computed: {
    productStorages: function () {
      return this.rawValues.product_storages || [];
    },
    rawValues: function () {
      return (
        this.$store.getters[config.storeNamespace + "/getItem"](this.$route.params.id) || {
          product: {},
          status: {},
        }
      );
    },
    values: function () {
      return this.$root.formatData(
        this.rawValues,
        this.config.fields.filter((field) => field.inDetail == true)
      );
    },
    currentBusiness: function () {
      return this.rawValues.reference_logs && this.rawValues.reference_logs.length
        ? (this.rawValues.reference_logs.find(log => !log.end_date) || {}).business
        : {};
    },
    currentEmployee: function () {
      return this.rawValues.reference_logs && this.rawValues.reference_logs.length
        ? (this.rawValues.reference_logs.find(log => !log.end_date) || {}).employee
        : {};
    },
    /**
     * Palier facturé à l'instant T. Le produit peut porter deux jeux de prix
     * (Axiloc historique + ESM) : on prend celui de la grille Axiloc, sur laquelle
     * current_price est calculé (ReferenceManager::getReferenceCurrentPrice).
     */
    currentPrice: function () {
      const groups = this.$store.getters["product/getPriceGroups"](
        this.rawValues.product && this.rawValues.product.prices
      );
      const group =
        groups.find((item) => item.code == "axiloc") || groups[0] || { prices: [] };

      return group.prices.find((price) => price.price_range == this.rawValues.current_price);
    },
    currentStock: function () {
      if (this.rawValues.product.unique_references) {
        let product_references = [...this.rawValues.product.unique_references, ...this.rawValues];
        return product_references.filter((item) => item.status.status_slug == "reference-en-stock")
          .length;
      }
    },
  },
  mounted() {
    // Chargement des champs à afficher dans le détail depuis la config
    // Et récupération des libellés
    config.fields
      .filter((field) => field.inDetail == true)
      .forEach((field) => {
        this.labels[field.name] = field.label;
    });

    this.isBusy = true;
    this.$store
      .dispatch(config.storeNamespace + "/getItem", {
        id: this.$route.params.id,
        wait: true,
      })
      .then(() => {
        // Test si le contenu demandé est bien trouvé
        let self = this;
        if (Object.entries(this.rawValues).length <= 2) {
          this.$toastr.error(
            "La fiche demandée n'a pas été trouvée. Assure-vous que l'URL saisie soit correcte."
          );
          setTimeout(function () {
            self.$router.go(-1);
          }, 5000);
          return;
        }
        this.isBusy = false;
      });
  },
  methods: {
    setToMaintenance(id){
      this.$store.dispatch("reference/setToMaintenance", id).then((response) => {
        this.$store.dispatch("reference/getItem", {id: this.$route.params.id, wait: false});
      });
    },
    setToInStock(id){
      this.$store.dispatch("reference/setToInStock", id).then((response) => {
        this.$store.dispatch("reference/getItem", {id: this.$route.params.id, wait: false});
      });
    },
    storageLabel(storage) {
      return environmentLabel(storage);
    },
  },
};
</script>

<style lang="scss">
.barcode-wrapper> :nth-child(1) {
  font-size: 22px;
}
</style>



// WEBPACK FOOTER //
// src/components/ReferenceMobile/ReferenceMobileDetail.vue